import { useContext } from "react";
import { Link } from "react-router-dom";
import {
  IconButton,
  Avatar,
  Box,
  Flex,
  HStack,
  VStack,
  useColorModeValue,
  Text,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FiMenu, FiChevronDown } from "react-icons/fi";
import ColorModeToggle from "../ColorModeToggle";
import { AuthContext } from "../../store/AuthContext";

const MobileNav = ({ onOpen, ...rest }) => {
  const { signOut } = useContext(AuthContext);
  const authContext = useContext(AuthContext);
  return (
    <Flex
      ml={{ base: 0, md: "260px" }}
      px={{ base: 4, md: 4 }}
      height="20"
      w={{ base: "full", md: "calc(100vw - 260px)" }}
      alignItems="center"
      position="fixed"
      bg={{
        base: useColorModeValue("white", "gray.900"),
        md: "transparent",
      }}
      justifyContent={{ base: "space-between", md: "flex-end" }}
      zIndex={50}
      {...rest}
    >
      <IconButton
        display={{ base: "flex", md: "none" }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Text
        display={{ base: "flex", md: "none" }}
        fontSize="2xl"
        fontWeight="bold"
      >
        Kasbon<Text as="span" color="kasbon.500">Ku.</Text>
      </Text>

      <HStack
        spacing={{ base: "2", md: "6" }}
        bg={{
          base: "transparent",
          md: useColorModeValue("gray.200", "gray.900"),
        }}
        px={{ base: 0, md: 2 }}
        borderRadius={10}
      >
        <ColorModeToggle />
        <Flex alignItems={"center"}>
          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: "none" }}
            >
              <HStack>
                <Avatar
                  size={"sm"}
                  src={
                    "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"
                  }
                />
                <VStack
                  display={{ base: "none", md: "flex" }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2"
                >
                  <Text fontSize="sm" maxW="100px" noOfLines={1}>{authContext.userName}</Text>
                  <Text fontSize="xs" color="gray.600">
                    {authContext.userRole}
                  </Text>
                </VStack>
                <Box display={{ base: "none", md: "flex" }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue("white", "gray.900")}
              borderColor={useColorModeValue("gray.200", "gray.700")}
            >
              <Link to="profile">
                <MenuItem>Profile</MenuItem>
              </Link>
              <MenuDivider />
              <MenuItem onClick={signOut}>Sign out</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};

export default MobileNav;
